/**
 * 前端接口配置
 */

 const rnd = Math.floor(Math.random()*99+1)

 export const quoteUrl:any  = {
    development: {
      qihuo: function(){ //期货接口
        return '//futsse-static.eastmoney.com/'
      },
      qihuo2: function(){ //期货接口
        return '//futsseapi.eastmoney.com/'
      },      
      quote: function(){ //行情接口
        return '//push2.eastmoney.com/'
      },
      quote_sse: function(){ //行情sse接口
        return '//' + rnd + '.push2.eastmoney.com/'
      },
      quote_ut: function(){ //行情接口ut
        return '7eea3edcaed734bea9cbfc24409ed989'
      },
      zixun: function(){
        return '//np-listapi.eastmoney.com/'
      },
      gonggao: function(){
        return '//np-anotice-stock-test.eastmoney.com/'
      },
      yanbao: function(){
        return '//np-areport-wap-test.eastmoney.com/'
      },
      datacenter: function(){
        return '//datacenter-web.eastmoney.com/'
      },
      quoteapi_level_test: function(){
        return '//push2-uatfj.eastmoney.com/'
      }

    },
    test: {
      qihuo: function(){
        return '//static.futssetest.eastmoney.com/'
      },
      qihuo2: function(){ //期货接口
        return '//futssetest.eastmoney.com/'
      },  
      quote:function(){
        return '//push2test.eastmoney.com/'
      },
      quote_sse: function(){ //行情sse接口
        return '//push2test.eastmoney.com/'
      },
      quote_ut: function(){
        return '7eea3edcaed734bea9cbfc24409ed989'
      },
      zixun: function(){
        return '//np-listapi-uat.eastmoney.com/'
      },
      gonggao: function(){
        return '//np-anotice-stock-test.eastmoney.com/'
      },
      yanbao: function(){
        return '//np-areport-wap-test.eastmoney.com/'
      },
      datacenter: function(){
        return '//testdatacenter.eastmoney.com/'
      }
    },
    level3: {
      qihuo: function(){
        return '//static.futssetest.eastmoney.com/'
      },
      qihuo2: function(){ //期货接口
        return '//futssetest.eastmoney.com/'
      },  
      quote:function(){
        return '//push2-uatfj.eastmoney.com/'
      },
      quote_sse: function(){ //行情sse接口
        return '//push2-uatfj.eastmoney.com/'
      },
      quote_ut: function(){
        return '7eea3edcaed734bea9cbfc24409ed989'
      },
      zixun: function(){
        return '//np-listapi-uat.eastmoney.com/'
      },
      gonggao: function(){
        return '//np-anotice-stock-test.eastmoney.com/'
      },
      yanbao: function(){
        return '//np-areport-wap-test.eastmoney.com/'
      },
      datacenter: function(){
        return '//testdatacenter.eastmoney.com/'
      },
      quoteapi_level_test: function(){
        return 'http://10.150.62.146:80/'
      }
    },
    production: {
      qihuo: function(){
        return '//futsse-static.eastmoney.com/'
      },
      qihuo2: function(){ //期货接口
        return '//futsseapi.eastmoney.com/'
      },  
      quote: function(){
        return '//push2.eastmoney.com/'
      },
      quote_sse: function(){ //行情sse接口
        return '//' + rnd + '.push2.eastmoney.com/'
      },
      quote_ut: function(){
        return '7eea3edcaed734bea9cbfc24409ed989'
      },
      zixun: function(){
        return '//np-listapi.eastmoney.com/'
      },
      gonggao: function(){
        return '//np-anotice-stock.eastmoney.com/'
      },
      yanbao: function(){
        return '//np-areport-wap.eastmoney.com/'
      },
      datacenter: function(){
        return '//datacenter-web.eastmoney.com/'
      }
    },
    getParam: function(name:string){
      let urlParam = location.search;
      let par:any = {};
      if (urlParam != "") {
        urlParam = urlParam.substring(1, urlParam.length);
        let param = urlParam.split("&");
        let paramName;
        let paramValue;
        for (let i = 0; i < param.length; i++) {
          paramName = param[i].substring(0, param[i].indexOf("="));
          paramValue = param[i].substring(param[i].indexOf("=") + 1, param[i].length);
          par[paramName] = paramValue;
        }
      }
      if(typeof (par[name]) != "undefined"){
        return par[name];
      }
      else{
        return null;
      }
    },
    getPath: function (name:string) {
      if (this.getParam('env')) {
        return this[this.getParam('env')][name]()
      }
      return this.production[name]()
    },
  }